import { Language } from './types';

const BASE_LANGUAGE_LABELS = {
  sessionHeader: 'Your session is about to expire',
  sessionSubHeader: 'You will be logged out in 1 minute',
  sessionExtend: 'Do you want to remain with your active session?',
  sessionConfirm: 'Keep signed in',
  sessionClose: 'Close session',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const SESSION_TIMEOUT_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    sessionHeader: 'Tu sesión está a punto de expirar',
    sessionSubHeader: 'Se cerrará tu sesión en 1 minuto',
    sessionExtend: '¿Deseas permanecer con tu sesión activa?',
    sessionConfirm: 'Mantener sesión',
    sessionClose: 'Cerrar sesión',
  },
};

export default SESSION_TIMEOUT_LANGUAGE_LABELS;
